const extractFilenameFromHeader = (header) => {
  return header
    .split(';')
    .find((n) => n.includes('filename='))
    .replace('filename=', '')
    .trim();
};

export default extractFilenameFromHeader;
